import _eol from "eol";
import _convertToPlainTextCustom from "../functions/quill/convertToPlainTextCustom.js";
import _convertToHtml from "../functions/quill/convertToHtml.js";
import _insertMissingOutcodes from "../functions/eventGroups/insertMissingOutcodes.js";
import _cheetahFunc from "../functions/profiles/cheetahBin.js";
import _tcLib from "../lib/timecode.js";
import _Event from "../classes/event.js";
const Event = _Event;
const tcLib = _tcLib;
const cheetahFunc = _cheetahFunc;
const insertMissingOutcodes = _insertMissingOutcodes;
const convertToHtml = _convertToHtml;
const convertToPlainTextCustom = _convertToPlainTextCustom;
const eol = _eol;
export default {
  decode: function (input, options) {
    let events = [],
      ccEvent,
      char,
      hexBuffer,
      header,
      tcFlag = false,
      textFlag = false,
      incodeHex,
      outcodeHex,
      italicFlag = false;
    hexBuffer = input.match(/(..?)/g);
    header = hexBuffer.splice(0, 128);
    /* debug logger */
    //console.log(header.join(" ") + "\n");
    //console.log(hexBuffer.join(" "));
    while (hexBuffer.length > 0) {
      char = hexBuffer.shift();
      if (!tcFlag) {
        if ((char === "61" || char === "62" || char === "63") && parseInt(hexBuffer[0], 16) < 24) {
          tcFlag = true;
          ccEvent = new Event();
          incodeHex = hexBuffer.splice(0, 4);
          outcodeHex = hexBuffer.splice(0, 4);

          /* Timecode Debug */
          // console.log(char);
          // console.log(incodeHex + "-->" + cheetahFunc.decodeTc(incodeHex));
          // console.log(outcodeHex + "-->" + cheetahFunc.decodeTc(outcodeHex));

          ccEvent.start = tcLib.tcToSec(cheetahFunc.decodeTc(incodeHex), options.frameRate, options.dropFrame);
          ccEvent.end = tcLib.tcToSec(cheetahFunc.decodeTc(outcodeHex), options.frameRate, options.dropFrame);
          italicFlag = false;
          let posData = hexBuffer.splice(0, 9);
          let vHex = parseInt(posData[7], 16);
          // console.log("vHex: " + vHex);
          //Convert vHex to an integer. If the integer is less than 6 than set yPos to start. If it's greater than 9 set yPos to end. Otherwise set yPos to middle.
          if (vHex < 6) {
            ccEvent.yPos = "start";
          } else if (vHex > 9) {
            ccEvent.yPos = "end";
          } else {
            ccEvent.yPos = "center";
          }
          textFlag = true;
        } else if ((char === "40" || char === "41" || char === "42" || char === "43") && parseInt(hexBuffer[0], 16) < 24) {
          tcFlag = true;
          ccEvent = new Event();
          incodeHex = hexBuffer.splice(0, 4);

          /* Timecode Debug */
          // console.log(char);
          // console.log(incodeHex + "-->" + cheetahFunc.decodeTc(incodeHex));

          ccEvent.start = tcLib.tcToSec(cheetahFunc.decodeTc(incodeHex), options.frameRate, options.dropFrame);
          italicFlag = false;
          if (char !== "40") {
            let posData = hexBuffer.splice(0, 9);
            let vHex = parseInt(posData[7], 16);
            // console.log("vHex: " + vHex);
            if (vHex < 6) {
              ccEvent.yPos = "start";
            } else if (vHex > 9) {
              ccEvent.yPos = "end";
            } else {
              ccEvent.yPos = "center";
            }
            textFlag = true;
          }
        }
      } else if (!textFlag && tcFlag) {
        if (char === "22") {
          textFlag = true;
          formatting = hexBuffer.splice(0, 8);
        } else if (char + hexBuffer[0] + hexBuffer[1] + hexBuffer[2] === "00000000") {
          ccEvent.text += "\n";
          tcFlag = false;
        }
      } else if (textFlag) {
        if (char + hexBuffer[0] + hexBuffer[1] + hexBuffer[2] === "00000000") {
          ccEvent.text += "\n";
          italicFlag = false;
          /* Remove the rest of the null codes */
          hexBuffer.splice(0, 3);
        } else if (char === "00" && hexBuffer[0] != "00") {
          if (parseInt(hexBuffer[1], 16) > 0 && parseInt(hexBuffer[1], 16) < 16) {
            if (italicFlag) {
              ccEvent.text += "</em>";
              italicFlag = false;
            }
            ccEvent.text += "\n";
            /* Remove the rest of the null codes */
            hexBuffer.splice(0, 3);
          } else {
            tcFlag = false;
            textFlag = false;
            //console.log(ccEvent.text);
            if (italicFlag) {
              ccEvent.text += "</em>";
              italicFlag = false;
            }
            ccEvent.text = ccEvent.text.replace(/<\/em><em>/g, "<\/em> <em>");

            // console.log(ccEvent.text);
            ccEvent.text = convertToHtml(ccEvent.text.trim());
            // console.log(ccEvent.text);
            events.push(ccEvent);
            hexBuffer.splice(0, 1);
          }
        } else if (parseInt(char, 16) >= 129 && parseInt(char, 16) <= 149) {
          /* Extended Characters */
          ccEvent.text += cheetahFunc.charLookup[char];
        } else if (char === "c0") {
          /* Open Italics */
          if (italicFlag) {
            ccEvent.text += "</em>";
            italicFlag = false;
          } else {
            ccEvent.text += "<em>";
            italicFlag = true;
          }
        } else if (char === "d0") {
          /* Close Italics */
          if (italicFlag) {
            ccEvent.text += "</em>";
            italicFlag = false;
          } else {
            ccEvent.text += "<em>";
            italicFlag = true;
          }
        } else {
          ccEvent.text += cheetahFunc.decodeChar(char, 1252);
        }
      }
    }
    return events;
  },
  encode: function (eventGroup, options) {
    try {
      // console.log(JSON.stringify(eventGroup, null, 4));
      /* ----Encode Header---- */
      let output = "ea220100"; //File Signature
      let totalEvents = eventGroup.events.length;
      const lowByte = totalEvents % 256;
      const highByte = Math.floor(totalEvents / 256);
      output += lowByte.toString(16).padStart(2, "0") + highByte.toString(16).padStart(2, "0"); //Number of subtitles
      output += "83F2D267"; // Fixed Bytes
      output = output.padEnd(256, "00");

      /* ----Encode Header Done---- */
      /* ----Encode Captions---- */
      eventGroup.events.forEach((event, eventIndex, events) => {
        // console.log("--------------------------------");
        // console.log(event)
        let subtitle = {
          text: convertToPlainTextCustom(event.text, "\n", false, "REMOVE_TAG", "em", "REMOVE_TAG"),
          start: cheetahFunc.encodeTc(event.startSmpte),
          end: cheetahFunc.encodeTc(event.endSmpte)
        };
        subtitle.lines = eol.split(subtitle.text);
        subtitle.type = subtitle.lines.length > 1 ? "62" : "61";
        subtitle.encodedText = cheetahFunc.encodeTextLines(subtitle.lines);
        subtitle.styleDataControlCodes = "22C302000000";
        subtitle.alignment = event.alignment === "left" ? "01" : event.alignment === "right" ? "02" : "03";
        subtitle.xPos = event.xPos === "start" ? "02" : event.xPos === "end" ? "1e" : "10";
        subtitle.yPos = event.yPos === "start" ? "01" : event.yPos === "end" ? "0f" : "08";
        subtitle.partial = subtitle.type + subtitle.start.join("") + subtitle.end.join("") + subtitle.styleDataControlCodes + subtitle.alignment + subtitle.yPos + subtitle.xPos + subtitle.encodedText;
        subtitle.length = (subtitle.partial.length / 2 + 1).toString(16).padStart(2, "0");
        output += subtitle.length + subtitle.partial;
        // console.log(subtitle);
      });
      return output;
    } catch (err) {
      console.error('Error encoding Cheetah Cap binary:', err);
      throw new Error("Cheetah Cap binary encoding failed: " + err.message);
    }
  },
  preProcess: {
    encode: function (eventGroup) {
      return eventGroup;
    },
    decode: function (input) {
      return input.toLowerCase();
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup, options) {
      eventGroup = insertMissingOutcodes(eventGroup);
      eventGroup.events = eventGroup.events.filter(event => {
        return event.end - event.start < 20;
      });
      return eventGroup;
    }
  }
};